// WIP
import React from 'react';

import EmployeeClickable from 'components/EmployeeClickable';
import CreateTask from 'components/MeshList/tasks/CreateTask';
import { HeaderContainer as SectionHeaderContainer } from 'components/SectionHeader';
import { StyledAvatar } from 'components/avatars';
import styled, { css } from 'styled-components';
import { FlexContainer, StyledIconContainer, StyledTypography, VerticalDivider, StyledTooltip } from 'styles/common';

import { TASK_TYPES_2 } from 'constants/ProjectConstants';
import {
  DelayedIcon,
  // EditIcon,
  ProgressIcon,
  OngoingShuttleIcon,
  CheckIcon,
  UpArrowIcon,
  DownArrowIcon,
  LeftRightArrowIcon,
} from 'constants/icons';
import theme from 'constants/theme';

const TASK_STATS_LABEL = ['Ongoing', 'Delayed', 'Completed', 'Unplanned'];
const GOAL_STATS_LABEL = ['On-Track', 'Off-Track', 'At-Risk', 'Closed'];
const TASK_STATS_ICONS = [
  { color: theme.palette.icons.green, icon: OngoingShuttleIcon },
  { color: theme.palette.icons.red, icon: DelayedIcon },
  { color: theme.palette.icons.blue, icon: CheckIcon },
  { color: theme.palette.icons.grey2, icon: ProgressIcon },
];
const GOAL_STATS_ICONS = [
  { color: theme.palette.icons.green, icon: UpArrowIcon },
  { color: theme.palette.icons.grey2, icon: LeftRightArrowIcon },
  { color: theme.palette.icons.red, icon: DownArrowIcon },
  { color: theme.palette.icons.blue, icon: CheckIcon },
];

const IconContainer = styled.div`
  display: block;
  svg {
    width: 0.8rem;
    height: 0.8rem;
    fill: ${(props) => (props.color ? props.color : '')};
  }
`;

export function StatsView({ className, type, stats }) {
  const statsValue = [
    type === TASK_TYPES_2.goal ? stats.onTrackProgress : stats.ongoing,
    type === TASK_TYPES_2.goal ? stats.offTrackProgress : stats.delayed,
    type === TASK_TYPES_2.goal ? stats.atRiskProgress : stats.completed,
    type === TASK_TYPES_2.goal ? stats.closedProgress : stats.unplanned,
  ];

  const currentTypeIcons = type === TASK_TYPES_2.goal ? GOAL_STATS_ICONS : TASK_STATS_ICONS;
  const currentTypeLabels = type === TASK_TYPES_2.goal ? GOAL_STATS_LABEL : TASK_STATS_LABEL;

  return (
    <StatsContainer>
      {statsValue.map((value, idx) => {
        const IconComponent = currentTypeIcons[idx].icon;
        return (
          <>
            <StyledTooltip title={currentTypeLabels[idx]}>
              <FlexContainer style={{ alignItems: 'center', padding: '.5rem' }}>
                <StyledIconContainer color={currentTypeIcons[idx].color}>
                  <IconComponent size="tinier" />
                </StyledIconContainer>
                <StyledTypography color="textSecondary" leftGutter={1.5}>
                  {value}
                </StyledTypography>
              </FlexContainer>
            </StyledTooltip>
            {idx < statsValue.length - 1 && <VerticalDivider height="14px" />}
          </>
        );
      })}
    </StatsContainer>
  );
}

export function UserDetail({ employee }) {
  return (
    <AvatarContainer unclickable={employee.isUnassignedUser()}>
      {!employee.isUnassignedUser() && (
        <EmployeeClickable employee={employee}>
          <StyledAvatar src={employee.getProfileImage()} size="small" />
        </EmployeeClickable>
      )}
      <EmployeeClickable employee={employee}>
        <div style={{ marginLeft: '1.5rem' }}>
          <StyledTypography topGutter={0.2} color="textSecondaryPrimary" variant="body2" style={{ fontSize: '18px' }}>
            {employee.fullName}
          </StyledTypography>
          <StyledTypography topGutter={0.5} color="textSecondary" variant="body2">
            {employee.designation}
          </StyledTypography>
        </div>
      </EmployeeClickable>
    </AvatarContainer>
  );
}

export default function TaskListHeaderV1({ employee, stats, type, createNewHandler, createNewInProgress }) {
  return (
    <StyledSectionHeaderContainer displayBorder>
      <Row>
        <UserDetail employee={employee} />
        <CreateTask
          createHandler={createNewHandler}
          createNewInProgress={createNewInProgress}
          size="big"
          type={type}
          employee={employee}
        />
      </Row>
      <StatsView type={type} stats={stats} />
    </StyledSectionHeaderContainer>
  );
}

const Row = styled.div`
  display: flex;
  justify-content: space-between;
  padding-top: 0.4rem;
`;

const StyledSectionHeaderContainer = styled(SectionHeaderContainer)`
  display: flex;
  min-height: 120px;
  flex-direction: column;
  align-items: normal;
`;

const StatsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const AvatarContainer = styled.div`
  display: inline-flex;
  align-items: center;
  ${(props) =>
    props.unclickable &&
    css`
      pointer-events: none;
      cursor: initial;
      // added extra padding = size of avatar, so that the unassigned task card is in inline with other task cards
      padding: 12px 0 !important;
      @media (min-width: 1440px) {
        padding: 14px 0 !important;
      }
    `}
`;
